import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './RefillBalance.scss';
import CurrencyField from '../CurrencyField/CurrencyField';
import Button from '../../_atomic/Button/Button';
import { TEXT_FIELD_STATUS, CONTEXT_PROVIDERS, SUCCESS } from '../../../utils/constants';
import { getFieldInitialState, currencyToCents, userAmountValidator } from '../../../utils/helpers';
import RefillFormContext from './RefillBalanceContext';
import ConnectedTextField from '../../_atomic/ConnectedTextField/ConnectedTextField';

const refillFieldName = 'refill';
const reasonFieldName = 'reason';


class RefillBalance extends Component {
  static propTypes = {
    refillBalance: PropTypes.func.isRequired,
    refillBalanceStatus: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    isAdmin: PropTypes.bool,
  }
  static defaultProps = {
    isAdmin: false,
  }
  constructor() {
    super();
    this.fields = {};
  }
  state = {
    fields: {
      [refillFieldName]: getFieldInitialState(undefined, undefined, 0),
      [reasonFieldName]: getFieldInitialState(),
    },
  };
  componentWillMount() {
    const { isAdmin } = this.props;
    const { fields } = this.state;
    if (!isAdmin) {
      fields[reasonFieldName].status = TEXT_FIELD_STATUS.VALID;
    }
  }
  componentDidUpdate(prevProps) {
    const { refillBalanceStatus, isAdmin } = this.props;
    if (refillBalanceStatus !== prevProps.refillBalanceStatus && refillBalanceStatus === SUCCESS) {
      const fields = { ...this.state.fields };
      fields[refillFieldName].value = '0';
      fields[refillFieldName].isFocused = false;
      if (isAdmin) {
        fields[reasonFieldName] = getFieldInitialState();
      }
      this.setState(() => ({
        fields,
      }));
    }
  }
  getFormStatus = (fields) => {
    let status = TEXT_FIELD_STATUS.INITIAL;
    let validFields = 0;
    let invalidFields = 0;
    const fieldsNames = Object.keys(fields);
    /* calc invalid fields coz form can have one VALID and one INITIAL field
               then form isn't valid or invalid it is initial */
    fieldsNames.forEach((name) => {
      if (fields[name].status === TEXT_FIELD_STATUS.VALID) {
        validFields += 1;
      }
      if (fields[name].status === TEXT_FIELD_STATUS.INVALID) {
        invalidFields += 1;
      }
    });
    if (validFields === fieldsNames.length) {
      status = TEXT_FIELD_STATUS.VALID;
    }

    if (invalidFields > 0) {
      status = TEXT_FIELD_STATUS.INVALID;
    }
    return status;
  };
  registerField = ({ name, validator }) => {
    this.fields[name] = {
      validator,
    };
  };

  fieldChangeHandler = ({ name, value }) => {
    const fields = {
      ...this.state.fields,
    };
    let formStatus = {
      ...this.state.formStatus,
    };
    fields[name].value = value;
    if (
      fields[name].status !== TEXT_FIELD_STATUS.INITIAL &&
      !fields[name].outerError
    ) {
      const { validator } = this.fields[name];
      const validate = validator(fields[name].value);
      fields[name].status = validate.status;
      fields[name].errorText = validate.errorText;
      formStatus = this.getFormStatus(fields);
    }

    this.setState(() => ({ fields, formStatus }));
  };

  fieldFocusHandler = ({ name, isFocused, value }) => {
    const fields = {
      ...this.state.fields,
    };
    let { formStatus } = {
      ...this.state.formStatus,
    };

    fields[name].isFocused = isFocused;
    if (!isFocused && value) {
      fields[name].value = value;
    }

    if (!isFocused) {
      const { validator } = this.fields[name];
      const validate = validator(fields[name].value);
      if (!fields[name].outerError) {
        fields[name].status = validate.status;
        fields[name].errorText = validate.errorText;
      }
      formStatus = this.getFormStatus(fields);
      // do in such "elegant" way, coz at shouldComponentUpdate nextState is equal to
      // this.state, when Context is used.
    }
    this.setState(() => ({ fields, formStatus }));
  };

  submitHandler = (e) => {
    e.preventDefault();
    const fields = { ...this.state.fields };
    Object
      .keys(this.fields)
      .forEach((name) => {
        const { validator } = this.fields[name];
        const validate = validator(fields[name].value);
        fields[name].status = validate.status;
        fields[name].errorText = validate.errorText;
      });
    const formStatus = this.getFormStatus(fields);
    this.setState(() => ({ fields, formStatus }), () => {
      if (formStatus === TEXT_FIELD_STATUS.VALID) {
        const amount = currencyToCents(fields[refillFieldName].value);
        const data = { amount };
        const { refillBalance, isAdmin, id } = this.props;
        if (isAdmin) {
          data.userId = id;
          data.reason = fields[reasonFieldName].value;
        }

        refillBalance(data);
      }
    });
  };

  render() {
    const { fields } = this.state;
    const { isAdmin } = this.props;
    const refillField = fields[refillFieldName];
    const reasonField = fields[reasonFieldName];
    return (
      <div className="refill-wrapper">
        <RefillFormContext.Provider
          value={{
            register: this.registerField,
            changeHandler: this.fieldChangeHandler,
            focusHandler: this.fieldFocusHandler,
          }}
        >
          <form onSubmit={this.submitHandler} className="refill-form">
            <div className="refill-field-wrapper">
              <CurrencyField
                name={refillFieldName}
                allowNegative={isAdmin}
                registerField={this.registerField}
                value={refillField.value}
                status={refillField.status}
                isFocused={refillField.isFocused}
                errorText={refillField.errorText}
                contextProvider={CONTEXT_PROVIDERS.RefillFormContext}
                floatCount={0}
                specifiedValidator={!isAdmin ? userAmountValidator : undefined}
                maxValue={10000000}
              />


              <Button label="Refill" type="submit" secondary />
            </div>
            <div className="reason-field-wrapper">
              {isAdmin &&
              <ConnectedTextField
                name={reasonFieldName}
                registerField={this.registerField}
                value={reasonField.value}
                status={reasonField.status}
                isFocused={reasonField.isFocused}
                errorText={reasonField.errorText}
                contextProvider={CONTEXT_PROVIDERS.RefillFormContext}
                isRequired={isAdmin}
                placeholder="Reason of refill"
                label="Reason of refill"
              />
            }
            </div>
          </form>
        </RefillFormContext.Provider>
      </div>
    );
  }
}

export default RefillBalance;



// WEBPACK FOOTER //
// ./src/components/_molecules/RefillBalance/RefillBalance.js